/* eslint-disable @typescript-eslint/no-explicit-any */
let tooltipEl: HTMLDivElement;
let shortcutEl: HTMLDivElement;
let tooltipTextEl: HTMLDivElement;
let targetEl: HTMLElement;

function createTooltip() {
  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.className = 'tooltip';
    tooltipEl.setAttribute('aria-hidden', 'true');

    if (!tooltipTextEl) {
      tooltipTextEl = document.createElement('div');
    }

    if (!shortcutEl) {
      shortcutEl = document.createElement('div');
    }

    tooltipEl.appendChild(tooltipTextEl);
    tooltipEl.appendChild(shortcutEl);
    document.body.appendChild(tooltipEl);
  }
}

function handlePointerEnter(event: PointerEvent) {
  if (!event.target || event.pointerType != 'mouse') {
    return; 
  }

  targetEl = event.target as HTMLElement;
  showTooltip();
}

function hideTooltip() {
  if (tooltipEl != undefined) {
    tooltipEl.style.visibility = 'hidden';
    tooltipEl.style.opacity = '0';
  }

  document.removeEventListener('keydown', escapeHandler);
  document.removeEventListener('scroll', hideTooltip);
}

function showTooltip() {
  if (tooltipEl == undefined) return;
  tooltipEl.style.visibility = 'visible';
  tooltipEl.style.opacity = '1';

  document.addEventListener('keydown', escapeHandler);
  document.addEventListener('scroll', hideTooltip, { capture: true, passive: true, once: true });

  const rect = targetEl.getBoundingClientRect();
  const position = targetEl.dataset.position;
  const tooltipText = targetEl.dataset.tooltip;
  const shortcut = targetEl.dataset.shortcut?.split('+');

  if (tooltipText) {
    tooltipTextEl.textContent = tooltipText;
    tooltipTextEl.style.display = 'block';
  } else {
    tooltipTextEl.style.display = 'none';
  }

  if (Array.isArray(shortcut)) {
    shortcutEl.style.display = 'block';
    shortcutEl.innerHTML = '';

    if (tooltipText) {
      shortcutEl.style.paddingTop = '6px';
    } else {
      shortcutEl.style.paddingTop = '0';
    }

    shortcut.forEach((item: string, index: number) => {
      const kbdElement = document.createElement('kbd');
      kbdElement.textContent = item.charAt(0).toUpperCase() + item.slice(1);
      shortcutEl.appendChild(kbdElement);

      if (index < shortcut.length - 1) {
        shortcutEl.appendChild(document.createTextNode('+'));
      }
    });
  } else {
    shortcutEl.style.display = 'none';
  }

  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  switch (position) {
    case 'top': {
      tooltipEl.style.top = (rect.top - tooltipEl.offsetHeight - 8) + 'px';
      let left = (rect.left + rect.width / 2 - tooltipEl.offsetWidth / 2);
      // Clamp to left and right viewport boundaries (+- 8 for some padding)
      left = Math.min(Math.max(left, 8), viewportWidth - tooltipEl.offsetWidth - 8);
      tooltipEl.style.left = left + 'px';
      break;
    }
    case 'bottom': {
      tooltipEl.style.top = (rect.bottom + 8) + 'px';
      let left = (rect.left + rect.width / 2 - tooltipEl.offsetWidth / 2);
      // Clamp to left and right viewport boundaries (+- 8 for some padding)
      left = Math.min(Math.max(left, 8), viewportWidth - tooltipEl.offsetWidth - 8);
      tooltipEl.style.left = left + 'px';
      break;
    }
    case 'left': {
      let top = (rect.top + rect.height / 2 - tooltipEl.offsetHeight / 2);
      // Clamp to top and bottom of viewport boundaries (+- 8 for some padding)
      top = Math.min(Math.max(top, 8), viewportHeight - tooltipEl.offsetHeight - 8);
      tooltipEl.style.top = top + 'px';
      tooltipEl.style.left = (rect.left - tooltipEl.offsetWidth - 8) + 'px';
      break;
    }
    case 'right': {
      let top = (rect.top + rect.height / 2 - tooltipEl.offsetHeight / 2);
      // Clamp to top and bottom of viewport boundaries (+- 8 for some padding)
      top = Math.min(Math.max(top, 8), viewportHeight - tooltipEl.offsetHeight - 8);
      tooltipEl.style.top = top + 'px';
      tooltipEl.style.left = rect.right + 8 + 'px';
      break;
    }
  }
}

function escapeHandler(event: KeyboardEvent) {
  if (event.key == 'Escape') {
    hideTooltip();
  }
}

export default {
  mounted(el: HTMLElement, binding: any) {
    if (!binding.value) {
      return; 
    }

    createTooltip();

    if (typeof binding.value == 'string') {
      el.ariaLabel = binding.value;
      el.dataset.tooltip = binding.value;
    } else if (binding.value.content) {
      el.ariaLabel = binding.value.content;
      el.dataset.tooltip = binding.value.content;
    }

    const position = (() => {
      if (binding.modifiers.left) {
        return 'left';
      } else if (binding.modifiers.right) {
        return 'right';
      } else if (binding.modifiers.top) {
        return 'top';
      } else if (binding.modifiers.bottom) {
        return 'bottom';
      } else {
        return 'left';
      }
    })();
    el.dataset.position = position;
    el.addEventListener('pointerenter', handlePointerEnter);
    el.addEventListener('pointerleave', hideTooltip);

    if (Array.isArray(binding.value.shortcut)) {
      el.ariaKeyShortcuts = binding.value.shortcut.join('+');
      el.dataset.shortcut = binding.value.shortcut.join('+');
    }
  },
  unmounted(el: HTMLElement) {
    hideTooltip();
    el.removeEventListener('pointerenter', handlePointerEnter);
    el.removeEventListener('pointerleave', hideTooltip);
  }
};